var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotification24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5c-2.502 0-4.85 2.003-4.85 4.8v4.3a.5.5 0 01-.276.447C6.003 14.483 5.5 15.231 5.5 16c0 .378.164.639.394.818.245.19.56.282.806.282h3a.5.5 0 01.5.5c0 .43.11.914.378 1.278.25.34.672.622 1.422.622.75 0 1.171-.282 1.422-.622.268-.364.378-.849.378-1.278a.5.5 0 01.5-.5h3c.245 0 .56-.092.805-.282A.987.987 0 0018.5 16c0-.77-.503-1.517-1.374-1.953a.5.5 0 01-.276-.447V9.3c0-2.797-2.348-4.8-4.85-4.8zM6.15 9.3c0-3.403 2.852-5.8 5.85-5.8 2.998 0 5.85 2.397 5.85 5.8v4.004c.98.59 1.65 1.568 1.65 2.696 0 .722-.336 1.261-.78 1.607-.43.335-.965.493-1.42.493h-2.535a3.027 3.027 0 01-.538 1.372c-.45.61-1.178 1.028-2.227 1.028s-1.777-.418-2.227-1.028a3.027 3.027 0 01-.538-1.372H6.7c-.455 0-.99-.158-1.42-.493A1.985 1.985 0 014.5 16c0-1.128.67-2.105 1.65-2.695V9.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification24);
export default __webpack_public_path__ + "static/media/icon-notification-24.90c274ab.svg";
export { ForwardRef as ReactComponent };